export default "__VITE_ASSET__1c57312a__"